<template>
  <div id="app">
 <!-- Loader starts-->
    <div class="loader-wrapper"  :class="{'loderhide' : !show }">

      <div class="loader bg-white">
        <div class="loader">
                <div class="line bg-primary"></div>
                <div class="line bg-primary"></div>
                <div class="line bg-primary"></div>
                <div class="line bg-primary"></div>
            </div>
      </div>

      <!--<div class="loader bg-white">
        <div class="whirly-loader"> </div>
      </div>-->
    </div>
  <!-- Loader ends-->

    <!--<Main/>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      show: true,
      interval: null,
      //usr_time_count_interval: null
    }
  },
  mounted() {
    this.timeOut();
    this.interval = setInterval(function () {
      this.loadData();
    }.bind(this), 60000); 
    /*this.usr_time_count_interval = setInterval(function () {
      this.contardor();
    }.bind(this), 1000); */
  },
  beforeDestroy: function(){
    clearInterval(this.interval);
    //clearInterval(this.usr_time_count_interval);
  },
  methods:{   
    timeOut(){
      var self = this;
      setTimeout(function(){
          self.show = false;
      }, 1000);
    },
    loadData: function () {

      this.getUserData()  
        .then(data => {
          if (data) {
            if (data.data) {
              if (data.data.misempresas) {
                localStorage.setItem('companies', JSON.stringify(data.data.misempresas));
              }
            }
          }
        })

    },
    /*contardor: function () {
      if (localStorage.usr_time_count_inprocess == 1) {
        localStorage.usr_time_count = parseInt(localStorage.usr_time_count?localStorage.usr_time_count:0) + 1
      }
    }*/
  }
}
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
